<template>
  <v-container v-if="canReadSubscriptions" fluid class="b-container">
    <v-sheet class="pa-3">
      <v-tabs
        v-model="tab"
        :vertical="$vuetify.breakpoint.mdAndDown"
        color="secondary"
        class="d-flex"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.name['en']"
          v-text="tab.name[lang]"
          :to="tab.to"
          class="text-capitalize d-flex justify-md-center px-3 flex-column"
        ></v-tab>
      </v-tabs>
    </v-sheet>

    <v-tabs-items v-model="tab" class="mt-3">
      <router-view></router-view>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Subscriptions',

  data() {
    return {
      tab: this.$route.path,
    };
  },

  computed: {
    ...mapGetters(['getPermission']),

    lang() {
      return this.$route.params.lang;
    },

    permissionsReady() {
      return (
        this.$store.state.superUser ||
        Object.keys(this.$store.state.permissions || {}).length > 0 ||
        Object.keys(this.$store.state.storePermissions || {}).length > 0
      );
    },

    canReadSubscriptions() {
      if (!this.permissionsReady) return null;
      return this.getPermission('subscriptions.read');
    },

    paymentError() {
      return this.$store.state.loyaltyPanel.paymentError;
    },

    tabs() {
      let arr = [];

      if (!this.paymentError) {
        arr.push({
          name: { el: 'Καταστήματα', en: 'stores', it: 'Negozi' },
          to: `/${this.lang}/loyaltyPanel/subscriptions/stores`,
        });
        if (this.getPermission('subscriptions.plans.read')) {
          arr.push({
            name: {
              el: 'Πλάνα Συνδρομής',
              en: 'Subscription Plans',
              it: 'Piani di abbonamento',
            },
            to: `/${this.lang}/loyaltyPanel/subscriptions/registration-plans`,
          });
        }

        if (this.getPermission('subscriptions.store_payment_methods.read')) {
          arr.push({
            name: {
              el: 'Μέθοδοι Πληρωμών',
              en: 'payment methods',
              it: 'Metodi di pagamento',
            },
            to: `/${this.lang}/loyaltyPanel/subscriptions/payment-methods`,
          });
        }
      }

      return arr;
    },
  },
  methods: {
    redirectForbidden() {
      this.$router.replace({
        name: 'Forbidden',
        params: {
          lang: this.lang || 'en',
        },
      });
    },
  },
  watch: {
    canReadSubscriptions: {
      immediate: true,
      handler(val) {
        if (this.permissionsReady && !val) {
          this.redirectForbidden();
        }
      },
    },
    $route: {
      immediate: true,
      handler(val) {
        this.tab = val.path;
        if (this.permissionsReady && !this.canReadSubscriptions) {
          this.redirectForbidden();
          return;
        }
        if (!this.permissionsReady) {
          return;
        }
        if (val.path === `/${this.lang}/loyaltyPanel/subscriptions`) {
          const firstTabRoute = this.tabs?.[0]?.to;
          if (firstTabRoute) {
            this.$router.push(firstTabRoute);
          }
        }
      },
    },
  },
};
</script>
<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
  width: 100%;
}

.v-tabs-bar.v-item-group > * {
  width: 100%;
}

.v-slide-group__content {
  width: 100%;
}

.my-subscription {
  background-color: #2a3042;
  color: white !important;
  border-radius: 5px 5px 0px 0px;
}
</style>
